
import { onClickOutside } from '@/directives/onClickOutside';

export default {
  directives: {
    'click-outside': onClickOutside,
  },

  props: {
    title: { type: String },
    initialDelay: { type: Number, default: 0 },
    length: { type: Number, default: 0 },
    countUnit: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
  },

  data() {
    return {
      opened: false,
      delay: 0,
      customDelay: 4,
      customInputting: false,
      toggleElementId: '',
    };
  },

  watch: {
    opened(val) {
      if (val) {
        this.$nextTick(() =>
          onClickOutside.bind(this.$refs.delaySelectContainer, {
            name: 'click-outside',
            value: this.toggle,
            param: false,
          })
        );
      } else {
        onClickOutside.unbind(this.$refs.delaySelectContainer);
      }
    },

    customDelay(val) {
      if ((typeof val === 'string' && val.length === 0) || val === undefined || val === null) {
        this.customDelay = 0;
      }

      if (typeof val === 'string' && val.search(/\D/) !== -1) {
        this.customDelay = val.replace(/\D/g, '');
      }

      if (typeof val === 'string' && val.charAt(0) === '0') {
        let substringFrom = 1;
        for (let i = 1; i < val.length; i++) {
          if (val[i] === '0') substringFrom++;
          else break;
        }

        const resultingNumber = val.substring(substringFrom, val.length);

        if (resultingNumber.length === 0) {
          this.customDelay = 0;
        } else {
          this.customDelay = parseInt(resultingNumber);
        }
      }
    },

    initialDelay: {
      immediate: true,
      handler(val) {
        if (this.delay !== val) this.delay = val;
      },
    },
  },

  methods: {
    cleanEventListeners() {
      const el = this.$refs.customInputRow;

      if (el) {
        onClickOutside.unbind(el, this.onCustomInputBlur);
        el.removeEventListener('keyup', this.onCustomInputEnter);
      }
    },

    toggle(e, state) {
      if (this.readonly) {
        return;
      }

      if (state === false || this.opened === true) {
        this.cleanEventListeners();
      }

      this.opened = state === undefined ? !this.opened : state;
      this.$emit('open-delay');
    },

    optionClicked(newDelay) {
      this.delay = newDelay;
      this.$emit('change-delay', newDelay);
    },

    focusCustomInput() {
      this.$refs.customInput.focus();
    },

    selectCustomInput() {
      this.customInputting = true;
      this.$nextTick(() => {
        const el = this.$refs.customInputRow;
        onClickOutside.bind(el, { name: 'click-outside', value: this.onCustomInputBlur });
        el.addEventListener('keyup', this.onCustomInputEnter);
        this.focusCustomInput();
      });
    },

    onCustomInputEnter(e) {
      if (e.key === 'Enter') this.onCustomInputBlur();
    },

    onCustomInputBlur(e) {
      this.cleanEventListeners();
      this.$nextTick(() => {
        this.customInputting = false;
        this.delay = typeof this.customDelay === 'string' ? this.customDelay.replace(/\D/g, '') : this.customDelay;
        this.$emit('change-delay', this.delay);
      });
    },
  },
};
